module.exports = __webpack_public_path__ + "img/frame (184).777323ed.jpg";